<!-- 大屏打开窗口 -->
<template>
  <div class="app-container">
    <div class="show-screen">
      <el-button type="primary" icon="el-icon-full-screen" class="link-button" @click="goBigScreen">{{ $t('text.dkdp') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {

  components: {},
  data () {
    return {
    }
  },
  methods: {
    goBigScreen () {
      const route = this.$router.resolve({
        name: this.$store.getters.station.id === 'def9678e8f7c423a80704f6151d0103a' ? 'bghn_fny_meterbigscreen' : 'mbigscreen',
        params: {
          id: this.$store.getters.station.id
        }
      })
      window.open(route.href, '_blank')
    }
  }
}
</script>
<style lang='stylus' scoped>
.app-container
  width: calc(100vw - 190px);
  height: calc(100vh - 100px);
  background-color:#0c1e39;
  background-size 100% 100%
  z-index 0
.link-button
  position absolute
  z-index 10
  left calc(50% - 58.5px)
  bottom -70px
.show-screen
  position absolute
  left calc(50% - 192px)
  top calc(50% - 108px - 70px)
  border 1px #ccc solid
  width 384px
  height 216px
  z-index 1
  background:url('../../assets/bg/big-bg.png') center center no-repeat
  background-size:cover
</style>
